import 'jquery.cookie';
import LazyLoad from "vanilla-lazyload";

global.$ = global.jQuery = require('jquery');
window.$dr = jQuery(document).ready;
window.LazyLoad = LazyLoad;

window.bootstrap = require('bootstrap5');

import 'jquery-match-height';

import CC from "cookieconsent";

import { Layout } from '../libs/layout.js';

jQuery(() => {
    Layout.initGlobalScripts();
});
